import { Paper, styled } from "@mui/material";

export const StyledPaper = styled(Paper)`
  padding: 0 1em;
`;
